export const Norm = {
	A: "A判定",
	B: "B判定",
	C: "C判定",
	D: "D判定",
} as const;

export type NormType = keyof typeof Norm;
